import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import moment from "moment";

export const SlotSuccessfullModal = ({
  isOpen,
  onCancel,
  onConfirm,
  data,
  ...rest
}) => {
  return (
    <Modal isOpen={isOpen} size={"md"} {...rest}>
      <ModalHeader toggle={onCancel}>Schedule Assessment</ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-12">
            <div className="assessment-modal-layout">
              <div className="modal-md-icon check-fill-icon"></div>
              <h3 className="modal-head-gray">
                Your Assessment Scheduled Successfully!
              </h3>
              <h4>
                {moment(data?.scheduledDate, "DD-MMM-YYYY").format(
                  "MMMM DD YYYY"
                )}
                <br />
                {data?.startAtStr} - {data?.endAtStr}
              </h4>
              <div className="modal-btn-group">
                <button
                  onClick={onConfirm}
                  className="assessment-md-btn px-5 tile-btn-blue"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
